<template>
    <div class="flex flex-col">
        <div class="flex flex-col w-full ml-8 justify-between">
            <div class="flex w-full items-start">
                <div class="flex flex-col w-1/4">
                    <label class="font-bold text-xs select-none mb-2" for="last_name">Datum / Raspon</label>
                    <vue-ctk-date-time-picker
                        class="form-control reports"
                        :class="{ _error: validationErrors.noDate }"
                        id="picked_date"
                        v-model="pickedDate"
                        label="Odaberite datum"
                        locale="hr"
                        format="YYYY-MM-DD"
                        formatted="DD.MM.YYYY."
                        :only-date="true"
                        :range="true"
                        :noShortcuts="true"
                    ></vue-ctk-date-time-picker>
                    <span
                        class="error-message"
                        v-if="validationErrors.noDate"
                        v-text="validationErrors.noDate[0]"
                    ></span>
                </div>
                <div class="w-1/4 mx-4">
                    <div class="form-group">
                        <label for="customer">Kupac</label>
                        <v-select
                            class="form-select"
                            id="customer"
                            :options="customerItems"
                            :clearable="false"
                            :multiple="true"
                            label="name"
                            :closeOnSelect="false"
                            :clearSearchOnSelect="false"
                        >
                            <template #selected-option-container="{ id }">
                                <div class="hidden">{{ id }}</div>
                            </template>
                            <template #option="{ name, id }">
                                <div
                                    class="form-group no-margin form-checkbox items-start justify-center w-full"
                                >
                                    <input
                                        class
                                        type="checkbox"
                                        :name="'customer-' + id"
                                        :id="'customer-' + id"
                                        v-model="customerItems[customerItems.findIndex(customer => customer.id == id)].selected"
                                    />
                                    <label
                                        class="w-full my-2 px-2 font"
                                        :for="'customer-' + id"
                                    >{{ name }}</label>
                                </div>
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="w-1/4 mx-4">
                    <div class="form-group">
                        <label for="project">Radni nalog</label>
                        <v-select
                            class="form-select"
                            id="project"
                            :options="projectItems"
                            :clearable="false"
                            :multiple="true"
                            label="name"
                            :closeOnSelect="false"
                            :clearSearchOnSelect="false"
                        >
                            <template #selected-option-container="{ id }">
                                <div class="hidden">{{ id }}</div>
                            </template>
                            <template #option="{ name, id }">
                                <div
                                    class="form-group no-margin form-checkbox items-start justify-center w-full"
                                >
                                    <input
                                        class
                                        type="checkbox"
                                        :name="'project-' + id"
                                        :id="'project-' + id"
                                        v-model="projectItems[projectItems.findIndex(project => project.id == id)].selected"
                                    />
                                    <label
                                        class="w-full my-2 px-2 font"
                                        :for="'project-' + id"
                                    >{{ name }}</label>
                                </div>
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="w-1/4 mx-4">
                    <div class="form-group">
                        <label for="users">Osoblje</label>
                        <v-select
                            class="form-select"
                            id="users"
                            :options="usersItems"
                            :clearable="false"
                            :multiple="true"
                            label="full_name_reverse"
                            :closeOnSelect="false"
                            :clearSearchOnSelect="false"
                        >
                            <template #selected-option-container="{ id }">
                                <div class="hidden">{{ id }}</div>
                            </template>
                            <template #option="{ full_name_reverse, id }">
                                <div
                                    class="form-group no-margin form-checkbox items-start justify-center w-full"
                                >
                                    <input
                                        class
                                        type="checkbox"
                                        :name="'users-' + id"
                                        :id="'users-' + id"
                                        v-model="usersItems[usersItems.findIndex(user => user.id == id)].selected"
                                    />
                                    <label
                                        class="w-full my-2 px-2 font"
                                        :for="'users-' + id"
                                    >{{ full_name_reverse }}</label>
                                </div>
                            </template>
                        </v-select>
                    </div>
                </div>
            </div>
            <div class="ml-auto mt-6 mr-8 flex">
                <a
                    :href="route('base.dump')"
                    class="mx-2 btn secondary export flex items-center"
                >Izvoz baze</a>
                <button class="mx-2 btn primary" @click="showDataForDate">Prikaži</button>
                <a
                    :href="route('reports.export', routeParams)"
                    class="mx-2 btn secondary export flex items-center"
                >Izvoz radnih sati</a>
                <!-- <button
                    class="mx-2 btn secondary export flex items-center"
                    @click="exportDataForDate"
                >Izvoz radnih sati</button>-->
            </div>
        </div>
        <hr class="my-8" />
        <div v-if="showCard" class="mx-8 flex flex-col">
            <div class="flex flex-col">
                <h1
                    class="font-heading font-bold text-xl"
                    v-if="pickedDate && pickedDate.end"
                >Suma za radoblje {{ pickedDate.start }} do {{ pickedDate.end }}</h1>
                <h1
                    class="font-heading font-bold text-xl"
                    v-else-if="pickedDate && pickedDate.start"
                >Suma za datum {{ pickedDate.start }}</h1>
                <h1
                    class="font-heading font-bold text-xl"
                    v-else
                >Suma od početka</h1>

                <div class="flex font-heading">
                    <div class="w-1/2">
                        <div class="flex justify-between w-2/3 mt-4">
                            <div class="flex flex-col">
                                <span class="my-2">Ukupan br. osoba:</span>
                                <span class="my-2">Ukupan br. radnih naloga:</span>
                            </div>
                            <div class="flex flex-col">
                                <span class="my-2">{{ totalWorkers }}</span>
                                <span class="my-2">{{ totalProjects }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="w-1/2">
                        <div class="flex justify-between w-2/3 mt-4">
                            <div class="flex flex-col">
                                <span class="my-2">Ukupan br. sati:</span>
                                <span class="my-2">Ukupan br. sati tehničko osoblje:</span>
                                <span class="my-2">Ukupan br. sati osoblje:</span>
                            </div>
                            <div class="flex flex-col">
                                <span class="my-2">{{ totalHours }}h</span>
                                <span class="my-2">{{ totalTechHours }}h</span>
                                <span class="my-2">{{ totalNonTechHours }}h</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex w-full">
                <div class="flex flex-col w-1/2 my-4">
                    <h1 class="font-heading font-bold text-xl">Suma po djelatniku</h1>
                    <span class="font-bold">Radni sati</span>
                    <div class="flex flex-col font-heading my-4 w-2/3">
                        <div
                            v-for="(worker, index) in workerHours"
                            :key="'worker-' + index"
                            class="flex justify-between"
                        >
                            <span class="my-2">{{ index + 1 }}.&nbsp;{{ worker.user.full_name_reverse }}</span>
                            <span v-if="worker.hours" class="my-2">{{ worker.hours }}h</span>
                            <span v-else class="my-2">-</span>
                        </div>
                    </div>
                    <span class="font-bold">Bolovanje</span>
                    <div class="flex flex-col font-heading my-4 w-2/3">
                        <div
                            v-for="(worker, index) in workerHours"
                            :key="'worker-' + index"
                            class="flex justify-between"
                        >
                            <span class="my-2">{{ index + 1 }}.&nbsp;{{ worker.user.full_name_reverse }}</span>
                            <span v-if="worker.sick_days" class="my-2">{{ worker.sick_days }} dan/a</span>
                            <span v-else class="my-2">-</span>
                        </div>
                    </div>
                    <span class="font-bold">Bolovanje - Rad</span>
                    <div class="flex flex-col font-heading my-4 w-2/3">
                        <div
                            v-for="(worker, index) in workerHours"
                            :key="'worker-' + index"
                            class="flex justify-between"
                        >
                            <span class="my-2">{{ index + 1 }}.&nbsp;{{ worker.user.full_name_reverse }}</span>
                            <span v-if="worker.sick_work_days" class="my-2">{{ worker.sick_work_days }} dan/a</span>
                            <span v-else class="my-2">-</span>
                        </div>
                    </div>
                    <span class="font-bold">Slobodni sati</span>
                    <div class="flex flex-col font-heading my-4 w-2/3">
                        <div
                            v-for="(worker, index) in workerHours"
                            :key="'worker-' + index"
                            class="flex justify-between"
                        >
                            <span class="my-2">{{ index + 1 }}.&nbsp;{{ worker.user.full_name_reverse }}</span>
                            <span v-if="worker.free_days" class="my-2">{{ worker.free_days }} dan/a</span>
                            <span v-else class="my-2">-</span>
                        </div>
                    </div>
                    <span class="font-bold">Godišnji odmor</span>
                    <div class="flex flex-col font-heading my-4 w-2/3">
                        <div
                            v-for="(worker, index) in workerHours"
                            :key="'worker-' + index"
                            class="flex justify-between"
                        >
                            <span class="my-2">{{ index + 1 }}.&nbsp;{{ worker.user.full_name_reverse }}</span>
                            <span
                                v-if="worker.vacation_days"
                                class="my-2"
                            >{{ worker.vacation_days }} dan/a</span>
                            <span v-else class="my-2">-</span>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col w-1/2 my-4">
                    <h1 class="font-heading font-bold text-xl">Suma za po radnom nalogu</h1>
                    <div class="flex flex-col font-heading mt-4 w-2/3">
                        <div
                            v-for="(project, index) in projectHours"
                            :key="'project-' + index"
                            class="flex justify-between"
                        >
                            <span class="my-2">{{ index + 1 }}.&nbsp;{{ project.project.name }}</span>
                            <span class="my-2">{{ project.hours }}h</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr class="my-12" />
        <div v-if="showCard" class="card mx-8">
            <div class="card-body flex flex-col">
                <div class="card-headers flex">
                    <div class="w-3/12 pt-6 px-4 border-b border-card-border border-opacity-10">
                        <h2 class="text-lg font-bold">Osoba</h2>
                    </div>
                    <div class="w-9/12 flex flex-col flex-grow pt-6 border-b border-l border-card-border border-opacity-10">
                        <div class="w-full pl-4">
                            <h2 class="text-lg font-bold">Vrijeme</h2>
                        </div>
                        <div class="w-full flex justify-center items-start">
                            <div class="w-1/6 font-light text-xs flex items-center h-full pl-4">
                                <span>RAD</span>
                            </div>
                            <div class="w-1/6 font-light text-xs flex items-center h-full pl-4">
                                <span>GO</span>
                            </div>
                            <div class="w-1/6 font-light text-xs flex items-center h-full pl-4">
                                <span>SL</span>
                            </div>
                            <div class="w-1/6 font-light text-xs flex items-center h-full pl-4">
                                <span>BO</span>
                            </div>
                            <div class="w-1/6 font-light text-xs flex items-center h-full pl-4">
                                <span>BOR</span>
                            </div>
                            <div class="w-1/6 font-light text-xs flex items-center h-full pl-4">
                                <span>TOTAL</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-for="(record, index) in usersReport" :key="'record-' + index" class="card-row flex">
                    <div class="w-3/12 py-4 px-4 border-b border-card-border border-opacity-10 flex items-center">
                        <h2 class="text-lg">{{ record.user.full_name_reverse }}</h2>
                    </div>
                    <div class="w-9/12 flex flex-col border-b border-l border-card-border border-opacity-10">
                        <div class="w-full h-full flex justify-center items-start">
                            <div class="time-cell border-l border-card-border border-opacity-10">
                                <span>{{ formatHours(record.hours.WORK) }}</span>
                            </div>
                            <div class="time-cell border-l border-card-border border-opacity-10">
                                <span>{{ formatHours(record.hours.VACATION) }}</span>
                            </div>
                            <div class="time-cell border-l border-card-border border-opacity-10">
                                <span>{{ formatHours(record.hours.FREE) }}</span>
                            </div>
                            <div class="time-cell border-l border-card-border border-opacity-10">
                                <span>{{ formatHours(record.hours.SICK) }}</span>
                            </div>
                            <div class="time-cell border-l border-card-border border-opacity-10">
                                <span>{{ formatHours(record.hours.BOR) }}</span>
                            </div>
                            <div class="time-cell border-l border-card-border border-opacity-10">
                                <span>{{ formatHours(record.hours.TOTAL) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <response v-if="showResponse" :data="responseData"></response>
    </div>
</template>

<script>
import Modal from "./Modal";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Response from "./Response";

export default {
    components: {
        VueCtkDateTimePicker,
        Modal,
        vSelect,
        Response,
    },

    props: {
        projectList: {
            type: Array,
            default: () => [],
            required: true,
        },
        statusList: {
            type: Array,
            default: () => [],
            required: true,
        },
        customerList: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            pickedDate: "",
            validationErrors: {},
            redirectMessage: "",
            showCard: false,
            showEditModal: false,
            workHours: [],
            usersReport: [],
            showResponse: false,
            responseData: {},
            projectItems: [],
            customerItems: [],
            usersItems: [],
            totalWorkers: "",
            totalProjects: "",
            totalHours: "00:00",
            totalTechHours: "00:00",
            totalNonTechHours: "00:00",
            workerHours: [],
            projectHours: [],
        };
    },

    created() {
        _.forEach(this.customerList, (customer, index) => {
            customer.selected = false;
            this.customerItems.push(customer);
        });

        _.forEach(this.projectList, (project, index) => {
            project.selected = false;
            this.projectItems.push(project);
        });
    },

    computed: {
        // NOTE: Commented for now, will be implemented maybe later
        // customerInputDisplay() {
        //     let selectedCount = 0
        //     let firstNameForDisplay = ''
        //     _.forEach(this.customerItems, customer => {
        //         if (customer.selected) {
        //             if (!firstNameForDisplay) {
        //                 firstNameForDisplay = customer.name
        //             }
        //             selectedCount++
        //         }
        //     })
        //     if (selectedCount > 1) {
        //         return firstNameForDisplay + ' ...'
        //     } else {
        //         return firstNameForDisplay
        //     }
        // },

        routeParams() {
            let params = {
                customers: [],
                projects: [],
                users: [],
                startDate: null,
                endDate: null
            };


            _.forEach(this.customerItems, (customer, index) => {
                if (customer.selected) {
                    params.customers.push(customer.id)
                }
            });

            _.forEach(this.projectItems, (project, index) => {
                if (project.selected) {
                    params.projects.push(project.id)
                }
            });

            _.forEach(this.usersItems, (user, index) => {
                if (user.selected) {
                    params.users.push(user.id)
                }
            });

            if (this.pickedDate && this.pickedDate.start) {
                params.startDate = this.pickedDate.start
            }

            if (this.pickedDate && this.pickedDate.end) {
                params.endDate = this.pickedDate.end
            }

            return params
        }
    },

    methods: {
        getRecordCustomerName(record) {
            if (record.project) {
                return record.project.customer.name;
            } else {
                return " ";
            }
        },

        toggleResponse() {
            this.showResponse = true;
            setTimeout(() => {
                this.showResponse = false;
            }, 2000);
        },

        closeEditForm() {
            this.showEditModal = false;
        },

        formatToHours(datetime) {
            if (
                moment(datetime, "YYYY-MM-DD HH:mm:ss").format("HH:mm") ==
                "Invalid date"
            ) {
                return "-";
            }

            return moment(datetime, "YYYY-MM-DD HH:mm:ss").format("HH:mm");
        },
        formatHours(hours) {
            if (hours == null) return "-";

            const hr = Math.floor(hours);
            const min = Math.round((hours - hr) * 60);
            return `${hr.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}`;
        },
        clearForm() {
            this.form = {
                record_status: "",
                record: {},
                record_index: "",
                start_time: "",
                end_time: "",
                remark: "",
            };
        },

        showEditForm(record, index) {
            this.showEditModal = true;
            this.form.record_index = index;
            this.form.record = record;
            this.form.start_time = record.start_time;
            this.form.end_time = record.end_time;
            this.form.record_status = this.statusList.find(
                (status) => status.name == record.leave
            );
        },

        calculateDiff(start_time, end_time) {
            let start = moment(start_time, "YYYY-MM-DD HH:mm:ss");
            let end = moment(end_time, "YYYY-MM-DD HH:mm:ss");
            let dif = end.diff(start);
            let formatted = moment.utc(dif).format("HH:mm");

            if (formatted == "Invalid date") {
                return "-";
            }

            return formatted;
        },

        timeAddition(current_time, add_time) {
            let cumulative = moment
                .duration(current_time, "HH:mm")
                .add(moment.duration(add_time, "HH:mm"));
            let newTime =
                Math.floor(cumulative.asHours()) +
                moment.utc(cumulative.asMilliseconds()).format(":mm");
            return newTime;
        },

        calculateReportData() {
            this.totalWorkers = "";
            this.totalProjects = "";
            this.totalHours = "00:00";
            this.totalTechHours = "00:00";
            this.totalNonTechHours = "00:00";
            this.workerHours = [];
            this.projectHours = [];

            _.forEach(this.workHours, (report, index) => {

                let timeDifference = report.total_time;

                // Gather all diferent workers and add their hours
                switch (report.leave) {
                    case "WORK":
                        if (!this.workerHours.find((record) => record.user.id == report.user.id)) {
                            this.workerHours.push({ user: report.user, hours: timeDifference });
                        } else {
                            let worker = this.workerHours.find((record) => record.user.id == report.user.id);
                            worker.hours = this.timeAddition(worker.hours, timeDifference);
                        }
                        break;
                    case "SICK":
                        if (report.has_work_injury) {
                            if (!this.workerHours.find((record) => record.user.id == report.user.id)) {
                                timeDifference = '08:00';
                                this.workerHours.push({ user: report.user, sick_work_days: 1 });
                            } else {
                                let worker = this.workerHours.find((record) => record.user.id == report.user.id);
                                timeDifference = '08:00';
                                if (!worker.sick_work_days) {
                                    worker.sick_work_days = 1;
                                } else {
                                    worker.sick_work_days++;
                                }
                            }
                        } else {
                            if (!this.workerHours.find((record) => record.user.id == report.user.id)) {
                                timeDifference = '05:36';
                                this.workerHours.push({ user: report.user, sick_days: 1 });
                            } else {
                                let worker = this.workerHours.find((record) => record.user.id == report.user.id);
                                timeDifference = '05:36';
                                if (!worker.sick_days) {
                                    worker.sick_days = 1;
                                } else {
                                    worker.sick_days++;
                                }
                            }
                        }
                        break;
                    case "VACATION":
                        if (!this.workerHours.find((record) => record.user.id == report.user.id)) {
                            timeDifference = '08:00';
                            this.workerHours.push({ user: report.user, vacation_days: 1 });
                        } else {
                            let worker = this.workerHours.find((record) => record.user.id == report.user.id);
                            timeDifference = '08:00';
                            if (!worker.vacation_days) {
                                worker.vacation_days = 1;
                            } else {
                                worker.vacation_days++;
                            }
                        }
                        break;
                    case "FREE":
                        if (!this.workerHours.find((record) => record.user.id == report.user.id)) {
                            timeDifference = '00:00';
                            this.workerHours.push({ user: report.user, free_days: 1 });
                        } else {
                            let worker = this.workerHours.find((record) => record.user.id == report.user.id);
                            timeDifference = '00:00';
                            if (!worker.free_days) {
                                worker.free_days = 1;
                            } else {
                                worker.free_days++;
                            }
                        }
                        return;
                    default:
                        break;
                }

                // Gather all diferent workers and add their hours
                if (report.leave == 'WORK') {
                    if (!this.projectHours.find((record) => record.project.id == report.project.id)) {
                        this.projectHours.push({ project: report.project, hours: timeDifference });
                    } else {
                        let project = this.projectHours.find((record) => record.project.id == report.project.id);
                        project.hours = this.timeAddition(project.hours, timeDifference);
                    }
                }

                if (report.leave !== 'FREE') {
                    this.totalHours = this.timeAddition(this.totalHours, timeDifference);

                    if (
                        report.user.roles[0].name == "installer_helper" ||
                        report.user.roles[0].name == "installer" ||
                        report.user.roles[0].name == "users_lead"
                    ) {
                        this.totalNonTechHours = this.timeAddition(this.totalNonTechHours, timeDifference);
                    } else {
                        this.totalTechHours = this.timeAddition(this.totalTechHours, timeDifference);
                    }
                }
            });

            this.totalWorkers = this.workerHours.length;
            this.totalProjects = this.projectHours.length;

        },

        showDataForDate() {
            this.fetchData();
        },

        fetchData() {
            this.showLoader();
            let formData = new FormData();
            let endpoint = "";

            _.forEach(this.customerItems, (customer, index) => {
                if (customer.selected) {
                    formData.append("customers[" + index + "]", customer.id);
                }
            });

            _.forEach(this.projectItems, (project, index) => {
                if (project.selected) {
                    formData.append("projects[" + index + "]", project.id);
                }
            });

            _.forEach(this.usersItems, (user, index) => {
                if (user.selected) {
                    formData.append("users[" + index + "]", user.id);
                }
            });

            if (this.pickedDate && this.pickedDate.start) {
                formData.append("start_date", this.pickedDate.start);
            }

            if (this.pickedDate && this.pickedDate.end) {
                formData.append("end_date", this.pickedDate.end);
            }

            endpoint = route("reports.fetch");

            // Send the formData to user controller store/update function depending on endpoint
            axios
                .post(endpoint, formData)
                .then((response) => {
                    if (response.status === 200) {
                        this.workHours = response.data.workHours;
                        this.usersReport = response.data.usersReport;
                        /* this.workHours.forEach((workHour, index) => {
                             console.log(`WorkHour ${index}:`, workHour.userReport);
                         });*/

                        this.usersItems = response.data.users;
                        this.projectItems = response.data.projects;
                        this.customerItems = response.data.customers;

                        if (this.usersReport.length) {
                            this.handleSelectedData(response.data.selected);

                            this.showCard = true;
                        }
                        this.calculateReportData();
                        this.hideLoader();
                    }
                })
                .catch((error) => {
                    if (typeof error.response !== "undefined") {
                        this.validationErrors = error.response.data.errors;
                    }

                    console.error(error);
                    this.hideLoader();
                });
        },

        handleSelectedData(parameters) {
            if (parameters.customers && parameters.customers.length > 0) {
                _.forEach(this.customerItems, (customer, index) => {
                    if (parameters.customers.includes(`${customer.id}`)) {
                        customer.selected = true;
                    }
                });
            }

            if (parameters.projects && parameters.projects.length > 0) {
                _.forEach(this.projectItems, (project, index) => {
                    if (parameters.projects.includes(`${project.id}`)) {
                        project.selected = true;
                    }
                });
            }

            if (parameters.users && parameters.users.length > 0) {
                _.forEach(this.usersItems, (user, index) => {
                    if (parameters.users.includes(`${user.id}`)) {
                        user.selected = true;
                    }
                });
            }
        }
    },
};
</script>
